export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'dashboard',
      },
    },
    {
      name: 'add-measure',
      displayName: 'menu.addMeasurement',
      meta: {
        icon: 'post_add',
      },
    },
    {
      name: 'my-evolution',
      displayName: 'menu.my-evolution',
      meta: {
        icon: 'bar_chart',
      },
    },
    {
      name: 'history',
      displayName: 'menu.history',
      meta: {
        icon: 'history',
      },
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'person',
      },
    },
  ] as INavigationRoute[],
}
